import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  
  // Check if path is active
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <header className="bg-tomato-50 py-6" role="banner">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex justify-center" aria-label="Main Navigation">
          <div className="bg-white shadow-md rounded-full p-1.5 flex space-x-2">
            <Link
              to="/"
              className={`px-6 py-2.5 text-xl font-medium rounded-full transition-all ${
                isActive('/') 
                  ? 'bg-tomato-600 text-white shadow-sm' 
                  : 'text-gray-700 hover:bg-tomato-50 hover:text-tomato-600'
              }`}
              aria-current={isActive('/') ? 'page' : undefined}
            >
              Timer
            </Link>
            
            <Link
              to="/about"
              className={`px-6 py-2.5 text-xl font-medium rounded-full transition-all ${
                isActive('/about') 
                  ? 'bg-tomato-600 text-white shadow-sm' 
                  : 'text-gray-700 hover:bg-tomato-50 hover:text-tomato-600'
              }`}
              aria-current={isActive('/about') ? 'page' : undefined}
            >
              About
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}
